import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
const originalPush = Router.prototype.push
 
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: resolve=>(require(["@/views/home"],resolve)),
      children: [
        {
          path: '/homeIndex',
          component: resolve=>(require(["@/views/homeIndex/index"],resolve)),
        }
      ]
    },
    {
      path: '/index',
      name: 'index',
      component: resolve=>(require(["@/views/index"],resolve)),
      children: [
        {
          path: '/searchPage',
          name: 'searchPage',
          component: resolve=>(require(["@/views/searchPage/index"],resolve)),
        },
        // {
        //   path: '/fzls',
        //   component: resolve=>(require(["@/views/secondaryPages/gywm/fzls"],resolve)),
        // },
        
        {
          path: '/sylmList',
          name: 'sylmList',
          component: resolve=>(require(["@/views/sylm/list"],resolve)),
        },
        {
          path: '/sylmDetail',
          name: 'sylmDetail',
          component: resolve=>(require(["@/views/sylm/detail"],resolve)),
        },
       
        {
          path: '/gywm',//gywm
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/jianjie',
              component: resolve=>(require(["@/views/secondaryPages/gywm/jianjie"],resolve)),
            },
            {
              path: '/zzkj',
              component: resolve=>(require(["@/views/secondaryPages/gywm/zzkj"],resolve)),
            },
            {
              path: '/fzls',
              component: resolve=>(require(["@/views/secondaryPages/gywm/fzls"],resolve)),
            },
            {
              path: '/xrld',
              component: resolve=>(require(["@/views/secondaryPages/gywm/xrld"],resolve)),
            },
          ]
        },
        
        {
          path: '/kxyj',//kxyj
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/kpzl',
              component: resolve=>(require(["@/views/secondaryPages/kxyj/kpzl"],resolve)),
            },
            {
              path: '/kydt',
              component: resolve=>(require(["@/views/secondaryPages/kxyj/kydt"],resolve)),
            },
            {
              path: '/kyxm',
              component: resolve=>(require(["@/views/secondaryPages/kxyj/kyxm"],resolve)),
            },
            {
              path: '/lwlz',
              component: resolve=>(require(["@/views/secondaryPages/kxyj/lwlz"],resolve)),
            },
            {
              path: '/zlyhj',
              component: resolve=>(require(["@/views/secondaryPages/kxyj/zlyhj"],resolve)),
            },
            {
              path: '/zzkt',
              component: resolve=>(require(["@/views/secondaryPages/kxyj/zzkt"],resolve)),
            }
          ]
        },
        {
          path: '/dwjs',
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/bshrc',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/bshrc"],resolve)),
            },
            {
              path: '/dsdw',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/dsdw"],resolve)),
            },
            {
              path: '/gljg',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/gljg"],resolve)),
            },
            {
              path: '/kytd',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/kytd"],resolve)),
            },
            {
              path: '/kyzl',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/kyzl"],resolve)),
            },
            
          ]
        },
        {
          path: '/djgz',
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/djgz',
              component: resolve=>(require(["@/views/secondaryPages/djgz/djgz"],resolve)),
            },
          ]
        },
        {
          path: '/rszp',//人事招聘
          component: resolve=>(require(["@/views/secondaryPages/dwjs/rszp/index"],resolve)),
          children: [
            {
              path: '/bshyj',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/rszp/bshyj"],resolve)),
            },
            {
              path: '/gccrc',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/rszp/gccrc"],resolve)),
            },
            {
              path: '/glry',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/rszp/glry"],resolve)),
            },
            {
              path: '/kyzlzp',
              component: resolve=>(require(["@/views/secondaryPages/dwjs/rszp/kyzlzp"],resolve)),
            },
          ]
        },
        {
          path: '/rcpy',
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/cxcy',
              component: resolve=>(require(["@/views/secondaryPages/rcpy/cxcy"],resolve)),
            },
            {
              path: '/jlzz',
              component: resolve=>(require(["@/views/secondaryPages/rcpy/jlzz"],resolve)),
            },
            {
              path: '/xszz',
              component: resolve=>(require(["@/views/secondaryPages/rcpy/xszz"],resolve)),
            },
            {
              path: '/yjsfc',
              component: resolve=>(require(["@/views/secondaryPages/rcpy/yjsfc"],resolve)),
            }
          ]
        },
        {
          path: '/kfjl',
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/cbhy',
              component: resolve=>(require(["@/views/secondaryPages/kfjl/cbhy"],resolve)),
            },
            {
              path: '/hzhb',
              component: resolve=>(require(["@/views/secondaryPages/kfjl/hzhb"],resolve)),
            },
            {
              path: '/jzbg',
              component: resolve=>(require(["@/views/secondaryPages/kfjl/jzbg"],resolve)),
            },
            {
              path: '/lt',
              component: resolve=>(require(["@/views/secondaryPages/kfjl/lt"],resolve)),
            },
            {
              path: '/ly',
              component: resolve=>(require(["@/views/secondaryPages/kfjl/ly"],resolve)),
            }
          ]
        },
        {
          path: '/yxgl',
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/glzd',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/glzd"],resolve)),
            },
            {
              path: '/zk',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/zk"],resolve)),
            },
            {
              path: '/ldbz',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/ldbz"],resolve)),
            },
            {
              path: '/lsh',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/lsh"],resolve)),
            },
            {
              path: '/sxkxj',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/sxkxj"],resolve)),
            },
            {
              path: '/xswyh',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/xswyh"],resolve)),
            },
            {
              path: '/zlzxwyh',
              component: resolve=>(require(["@/views/secondaryPages/yxgl/zlzxwyh"],resolve)),
            }
          ]
        },
        {
          path: '/ptjs',
          component: resolve=>(require(["@/views/secondaryPages/index"],resolve)),
          children: [
            {
              path: '/dxyqsb',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/dxyqsb"],resolve)),
            },
            {
              path: '/gnyzpt',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/gnyzpt"],resolve)),
            },
            {
              path: '/ptgk',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/ptgk"],resolve)),
            },
            {
              path: '/rdhystyltzx',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/rdhystyltzx"],resolve)),
            },
            {
              path: '/scnfzzcxzx',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/scnfzzcxzx"],resolve)),
            },
            {
              path: '/shtcyzbzx',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/shtcyzbzx"],resolve)),
            },
            {
              path: '/znsycysznhzx',
              component: resolve=>(require(["@/views/secondaryPages/ptjs/znsycysznhzx"],resolve)),
            }
          ]
        },
        
      ]
    },
    // {//登录注册
    //   path: '/loginRegister',
    //   name: 'loginRegister',
    //   component: resolve=>(require(["@/views/loginRegister/index"],resolve)),
    // },
    // {//
    //   path: '/banner',
    //   name: 'banner',
    //   component: resolve=>(require(["@/views/banner/index"],resolve)),
    // }
  ]
});